import { SetOfDayTypesAPI } from '../../../api/datamanager/SetOfDayTypesAPI';

export class SetOfDayTypesCommand {
    getAll(provider, successCallback, errorCallback) {
        const apiResult = SetOfDayTypesAPI.list(provider);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(setOfDayTypes, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(0 === setOfDayTypes.id) {
            apiResult = SetOfDayTypesAPI.create(setOfDayTypes);
            successMessage = "Conjunto de Tipos de Dia criado com sucesso";
        }
        else {
            apiResult = SetOfDayTypesAPI.update(setOfDayTypes.id, setOfDayTypes);
            successMessage = "Conjunto de Tipos de Dia editado com sucesso";
        }
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback(successMessage);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(setOfDayTypesId, successCallback, errorCallback) {
        const apiResult = SetOfDayTypesAPI.delete(setOfDayTypesId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Conjunto de Tipos de Dia eliminado com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/SetOfDayTypesCommand.js